import {Crew} from "./crew";

export class OrderDraftCrewFilter {
  crew: Crew;
}
